module.exports = __webpack_public_path__ + "static/media/man2.b5c69b62.png";